import { Checkbox } from "@mui/material";

const fallbackSelectionKey = (testCase) => {
  const itemId = testCase?.idtest_case ?? testCase?.idtest_suite;
  return itemId != null ? `${itemId}` : null;
};

const ChildCheckBox = ({ addTestCase, caseToBeAdded, item, getSelectionKey = fallbackSelectionKey }) => {
  const itemSelectionKey = getSelectionKey(item);
  const isChecked = Boolean(
    itemSelectionKey &&
      caseToBeAdded?.some((selectedItem) => {
        return getSelectionKey(selectedItem) === itemSelectionKey;
      }),
  );

  return (
    <Checkbox sx={{ p: 0, mr: 2 }} onChange={addTestCase} checked={isChecked} />
  );
};

export default ChildCheckBox;
